export default __webpack_public_path__ + "static/media/send-mail-icon.fda1415d.svg";